import { render, staticRenderFns } from "./EventChat.vue?vue&type=template&id=de7ebd36"
import script from "./EventChat.vue?vue&type=script&lang=js"
export * from "./EventChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports